import { ContactDtoIn } from '@/models/in/ContactDtoIn';
import userIcon from '@/assets/icons/user.svg';
import id2Icon from '@/assets/icons/id2.svg';
import selectedIcon from '@/assets/icons/selected-v.svg';
import styles from './ChooseSupported.module.scss';

interface SupportedListItemProps {
  supported: ContactDtoIn;
  isSelected: boolean;
  onClick: (supported: ContactDtoIn) => void;
}

const SupportedListItem = ({ supported, isSelected, onClick }: SupportedListItemProps) => {
  return (
    <div className={`${styles.supportedListItem} ${isSelected ? styles.selected : ''}`} onClick={() => onClick(supported)}>
      <div className={`${styles.innerContent} ${isSelected ? styles.selected : ''}`}>
        <div className={styles.details}>
          <div className={`${styles.itemContent} min-w-0 max-w-[200px]`}>
            <img src={userIcon} alt="User Icon" width={20} height={20} />
            <span className="body-lr-regular text-(--font-body-1) overflow-hidden text-ellipsis whitespace-nowrap">
              {supported.firstName} {supported.lastName}
            </span>
          </div>
          <div className={styles.itemContentWithDivider}>
            <div className={styles.divider}></div>
            <div className={styles.itemContent}>
              <img src={id2Icon} alt="ID Icon" width={20} height={20} />
              <span className="body-lr-regular text-(--font-body-1)">
                {supported.israeliId}
              </span>
            </div>
          </div>
        </div>
        {isSelected && (
          <img src={selectedIcon} alt="Selected" width={20} height={20} className={styles.selectedIcon} />
        )}
      </div>
    </div>
  );
};

export default SupportedListItem;

